export default "__VITE_ASSET__CMnJMiK5__"